export class NotImplementedError extends Error {
  constructor(message) {
    super(message)
    this.message = message
    this.name = this.constructor.name
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor)
    }
  }
}
